import React, { useState } from "react";
import axios from "axios";
import {  useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Layout from "../../components/Layout/Layout";
import { useAuth } from "../../context/auth";
const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    //custom hooks call
    const [auth, setAuth] = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    //form section    
    // form function
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post("https://bablu-server.onrender.com/auth/login", {
                email,
                password,
            });
            if (res && res.data.success) {
                toast.success(res.data.message);
                setAuth({
                    ...auth,
                    user: res.data.user,
                    token: res.data.token
                })
                localStorage.setItem("auth", JSON.stringify(res.data))
                navigate(location.state || "/");
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };
    return (
        <Layout>
            <div className=" form_container mt-5">


                <form onSubmit={handleSubmit}>
                <h4 className='text-center mt-3'>Login</h4>
                    <div className="formInput">

                    <div className="mb-3 form_input">
                        <label htmlFor="exampleInputEmail1" className="form-label">Email address</label>
                        <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder='Enter your Email' value={email} onChange={(e) => setEmail(e.target.value)} />
                        <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                    </div>
                    <div className="mb-3 form_input">
                        <label htmlFor="exampleInputPassword1" className="form-label">Password</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" placeholder='Enter password' value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button type="submit" className="form_button">Submit</button>
                    <p onClick={()=>{navigate('/forgotPassword')}} style={{cursor:'pointer'}}>Fogot Password</p> <br />
                    </div>
                </form>
                {/* const handleSubmit = async (e) => {
e.preventDefault();
// console.log(name, email, phone, password, address);
// toast.success("Register SuccessFull.")
try {
    const res = await axios.post("https://bablu-server.onrender.com/auth/register", { name, email, phone, password, address });
    if (res && res.data.success) {
        toast.success(res.data && res.data.message);
        navigate('/');

    } else {
        toast.error(res.data.message);
    }
} catch (error) {
    console.log(error);
    toast.error("Something went wrong!");
}
} */}
            </div>
        </Layout>
    )
}

export default Login





















